const TBAutomationActionTypes = {
  SET_TB_MESSAGE: 'SET_TB_MESSAGE',
  SET_STATUS: 'SET_STATUS',
  SET_COLOR: 'SET_COLOR',
  RESET_STATE: 'RESET_STATE',
  GET_LAST_RUN_START: 'GET_LAST_RUN_START',
  GET_LAST_RUN_SUCCESS: 'GET_LAST_RUN_SUCCESS',
  GET_LAST_RUN_FAILURE: 'GET_LAST_RUN_FAILURE',
};

export default TBAutomationActionTypes;
